/// <reference path="../../typings/jquery/jquery.d.ts" />
/// <reference path="../../typings/jquery/jquery.extensions.d.ts" />
/// <reference path="../tracking/interfaces.ts" />
/// <reference path="../../common/interfaces.ts" />
/// <reference path="../query-string-utils.ts" />
/// <reference path="../cookies.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        var SearchOptions = (function () {
            function SearchOptions($, storage, queryString, config, siteConfig) {
                this.localStorageKey = "searchOptions";
                this.$ = $;
                this.storage = storage;
                this.querystring = queryString;
                this.config = config;
                this.siteConfig = siteConfig;
                if (this.$.isNullOrUndefined($)) {
                    throw new Error("'$' was not specified.");
                }
                if (this.$.isNullOrUndefined(storage)) {
                    throw new Error("'storage' was not specified.");
                }
                if (this.$.isNullOrUndefined(config)) {
                    throw new Error("'config' was not specified.");
                }
                if (this.$.isNullOrUndefined(siteConfig)) {
                    throw new Error("'siteConfig' was not specified.");
                }
                if (this.$.isNullOrUndefined(location)) {
                    throw new Error("'location' was not specified.");
                }
            }
            SearchOptions.prototype.populateUsersPreviousSearchCriteria = function (searchBar) {
                if (this.storage.isLocalStorageSupported() === false) {
                    return;
                }
                var storageCriteria = this.storage.getItem(this.localStorageKey);
                if (storageCriteria == null) {
                    return;
                }
                var searchCriteria = JSON.parse(storageCriteria);
                var keywordsTextBox = $(".search-keywords", $(searchBar));
                var locationTextBox = $(".search-location-text", $(searchBar));
                var radiusDropdown = $(".search-locationsearchtype", $(searchBar));
                keywordsTextBox.val(searchCriteria.keywords);
                locationTextBox.val(searchCriteria.location);
                keywordsTextBox.trigger('change');
                locationTextBox.trigger('change');
                if ($.isNullOrUndefined(searchCriteria.radius) === false) {
                    if (radiusDropdown.find('option[value="' + searchCriteria.radius + '"]').length > 0) {
                        radiusDropdown.val(searchCriteria.radius);
                    }
                }
                if ($.isNullOrUndefined(searchCriteria.duration) === false) {
                    if (radiusDropdown.find('option[value="CTD_' + searchCriteria.duration + '"]').length > 0) {
                        radiusDropdown.val("CTD_" + searchCriteria.duration);
                    }
                }
            };
            SearchOptions.prototype.initialize = function (searchBar) {
                if (this.storage.isLocalStorageSupported() === false) {
                    return;
                }
                this.storeSearchOptionsFromQueryString();
                this.populateUsersPreviousSearchCriteria(searchBar);
            };
            SearchOptions.prototype.getSearchOptionsFromQueryString = function () {
                var parameters = this.querystring.getQueryStringParameters();
                return {
                    keywords: parameters["keywords"],
                    location: parameters["ltxt"],
                    radius: parameters["radius"],
                    duration: parameters["duration"]
                };
            };
            SearchOptions.prototype.storeSearchOptionsFromQueryString = function () {
                var currentSearchOptions = this.getSearchOptionsFromQueryString();
                var oldSearchCriteriaAsString = this.storage.getItem(this.localStorageKey);
                var storedSearchCriteria = $.isNullOrUndefined(oldSearchCriteriaAsString) ? {} : JSON.parse(oldSearchCriteriaAsString);
                var anySearchKeywords = !$.isNullOrUndefined(currentSearchOptions.keywords) ||
                    !$.isNullOrUndefined(currentSearchOptions.location) ||
                    !$.isNullOrUndefined(currentSearchOptions.radius) ||
                    !$.isNullOrUndefined(currentSearchOptions.duration);
                if (!anySearchKeywords) {
                    return false;
                }
                var hasChanged = false;
                if (currentSearchOptions.keywords !== storedSearchCriteria.keywords) {
                    storedSearchCriteria.keywords = currentSearchOptions.keywords;
                    hasChanged = true;
                }
                if (currentSearchOptions.location !== storedSearchCriteria.location) {
                    storedSearchCriteria.location = currentSearchOptions.location;
                    hasChanged = true;
                }
                if (currentSearchOptions.radius !== storedSearchCriteria.radius) {
                    storedSearchCriteria.radius = currentSearchOptions.radius;
                    hasChanged = true;
                }
                if (currentSearchOptions.duration !== storedSearchCriteria.duration) {
                    storedSearchCriteria.duration = currentSearchOptions.duration;
                    hasChanged = true;
                }
                if (hasChanged) {
                    var value = JSON.stringify(storedSearchCriteria);
                    this.storage.setItem(this.localStorageKey, value);
                }
                return hasChanged;
            };
            return SearchOptions;
        }());
        Header.SearchOptions = SearchOptions;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=header-search-options.js.map
